const columns = [
    {
      title: 'Login',
      dataIndex: 'login',
      // sorter: (a, b) => a?.login - b?.login,
    },
    {
      title: 'Platform',
      dataIndex: 'platform',
      // sorter: (a, b) => a?.platform?.localeCompare(b?.platform),
    },
    {
      title: 'A/C Type',
      dataIndex: 'acType',
      // sorter: (a, b) => a?.acType?.localeCompare(b?.acType),
    },
    {
      title: 'Balance',
      dataIndex: 'balances',
    },
    {
      title: 'Leverage',
      dataIndex: 'leverage',
      // sorter: (a, b) => a?.leverage - b?.leverage,
    },
    {
      title: 'Currency',
      dataIndex: 'currency',
      // sorter: (a, b) => a?.currency?.localeCompare(b?.currency),
    },
  
    {
      title: 'Created At',
      dataIndex: 'createdAt',
      // sorter: (a, b) => ((new Date(a.createdAt)) - (new Date(b.createdAt))),
    },
    {
      title: 'Status',
      dataIndex: 'status',
    },
  ];
  
  export default columns;